var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("\n      " + _vm._s(_vm.subscription.name) + "\n      "),
        _vm.state
          ? _c("div", { class: "chip " + _vm.state.color }, [
              _vm._v(_vm._s(_vm.state.name))
            ])
          : _vm._e()
      ]),
      _vm._v("Pedidos com\n    "),
      _c("b", [
        _vm._v(
          _vm._s(_vm._f("secToHours")(_vm.subscription.order_duration)) +
            " horas"
        )
      ]),
      _vm._v(" de duração com\n    "),
      _c("b", [
        _vm._v(
          _vm._s(_vm.subscription.professional.account.first_name) +
            " " +
            _vm._s(_vm.subscription.professional.account.last_name)
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "professional" }, [
      _c("img", {
        attrs: {
          src: "https://donamaid.com/dist/donie.png",
          alt: "Donamaid Manager"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7af13fb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af13fb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscriptions/Subscription/Header.vue
// module id = null
// module chunks = 